export enum ScrollStateEnum {
  IDLE = 0,
  HORIZONTAL = 1,
  VERTICAL = 2,
}
